import "./ifSwitchBranchEditor.0.css";
import SimpleFlowStepList from '../../../simpleFlow/SimpleFlowEditor/SimpleFlowStepList';
import ExprInput from '../../../comps/ExprInput';
import { EventTitleFlex } from "../../../../lib/comps/PropPanel/EventPanelNew/EventTitleFlex";
import { EventPanelIcons } from "../../../../lib/comps/PropPanel/EventPanelNew/eventPanelIcons";
const __script_base__ = {
  name: 'IfSwitchBranchEditor',
  components: {
    ExprInput,
    EventTitleFlex,
    SimpleFlowStepList
  },
  data() {
    return {
      arrowDownIcon: EventPanelIcons.arrowDown,
      disableIcon: EventPanelIcons.disableIcon,
      disdisableIcon: EventPanelIcons.disdisableIcon
    };
  },
  props: {
    value: Object,
    index: {
      type: Number,
      required: true
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  methods: {
    toggleDisabled() {
      this.$set(this.value, 'disabled', !this.value.disabled);
    },
    toggleExpanded() {
      this.$set(this.value, 'expanded', !this.value.expanded);
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("EventTitleFlex", {
    staticClass: "ucd-sfeStep ucd-ifSwitchBranchEditor",
    class: {
      isExpanded: !!_vm.value.expanded,
      isDisabled: !!_vm.value.disabled
    }
  }, [_c("a-tooltip", {
    attrs: {
      slot: "toggle",
      placement: "leftTop",
      title: _vm.value.disabled ? "分支已禁用，点击启用" : "点击禁用此条件分支"
    },
    on: {
      click: _vm.toggleDisabled
    },
    slot: "toggle"
  }, [_c("div", {
    staticClass: "ucd-sfeStep-toggle"
  }, [_c("div", {
    class: "ucd-sfeToggle small " + (_vm.value.disabled ? "isGrey" : "isYellow")
  }, [_vm._v("\n        " + _vm._s(_vm.index + 1) + "\n      ")])])]), _vm._v(" "), _c("div", {
    staticClass: "ucd-sfeStep-title ucd-ifSwitchBranchEditor-header",
    attrs: {
      slot: "title"
    },
    on: {
      click: _vm.toggleExpanded
    },
    slot: "title"
  }, [_c("div", {
    staticClass: "ucd-sfeStep-title-name ucd-ifSwitchBranchEditor-title"
  }, [_c("div", {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_vm._v("\n        如果\n      ")]), _vm._v(" "), _c("ExprInput", {
    attrs: {
      placeholder: "表达式",
      "notify-void-return": true
    },
    nativeOn: {
      click: function ($event) {
        $event.stopPropagation();
      }
    },
    model: {
      value: _vm.value.condition,
      callback: function ($$v) {
        _vm.$set(_vm.value, "condition", $$v);
      },
      expression: "value.condition"
    }
  })], 1), _vm._v(" "), _c("div", {
    staticClass: "ucd-sfeStep-actions",
    on: {
      click: function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c("button", {
    staticClass: "ucd-sfeStep-button ucd-sfeStep-arrowButton",
    on: {
      click: _vm.toggleExpanded
    }
  }, [_c("img", {
    class: {
      Rotate: _vm.value.expanded
    },
    attrs: {
      src: _vm.arrowDownIcon
    }
  })]), _vm._v(" "), _vm._t("actions")], 2)]), _vm._v(" "), _vm.value.expanded ? _c("div", {
    staticClass: "ucd-sfeStep-params"
  }, [_c("SimpleFlowStepList", {
    attrs: {
      steps: _vm.value.steps
    }
  })], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "builtin/designerComponents/IfSwitchBranchList/ifSwitchBranchEditor.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);